/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ChoiceList/view.blocks to change it.
import * as fromData from 'Simple/Data'
import Choice from 'DesignSystem/Choice/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ChoiceList({
  children,
  viewPath = "/DesignSystem/ChoiceList",
  from,
  onClick,
  selected
  
}) {
  return (<React.Fragment
>
<div
  data-testid="ChoiceList.ChoiceList"
  data-view-path={viewPath}
 className={`views-block ${styles.ChoiceList1}`}
>
{Array.isArray(from) && from.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="choice"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Choice(${item?.id ?? item?._id ?? index})`}
      >
<Choice
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Choice(${item?.id ?? item?._id ?? index})`}
 alignSelf="self-start"
 marginLeft={0}
 marginRight={0}
 marginTop={4}
 paddingBottom={15}
 paddingTop={15}
 width="100%"
 onClick={onClick}
 selected={selected}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }